<template>
  <div>
    <div class="comm_popup_wrap_medium">
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TIT_NODE_INFO') }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_NODE_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ nodeId }}
            </div>
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_NODE_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ selectedRowData.nodeName }}
            </div>
          </div>
        </div>
      </div>
      <div class="mrB30" />
      <div class="comm_title_wrap">
        <h4>{{ $t('MSG_TIT_PRMT_MGT') }}</h4>
      </div>
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsNodeParam'"
        :showDisplayCountControl="false"
        :showMoveControl="false"
        :multiselect="true"
      >
        <div class="comp_spacing" />
        <div class="btn_wrapL">
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickRowAdd"
          >
            {{ $t('MSG_BTN_ROW_ADD') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickRowDelete"
          >
            {{ $t('MSG_BTN_ROW_DEL') }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_gridTop"
            @click="onClickRowCancel"
          >
            {{ $t('MSG_BTN_CANCEL') }}
          </sui-button>
        </div>
      </sui-grid>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="$emit('onClickClose')"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onClickSave"
      >
        {{ $t('MSG_BTN_SAVE') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onClickApply"
      >
        {{ $t('MSG_BTN_APPLY') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00004_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: null,
    },
    nodeId: {
      type: String,
      default: null,
    },
    selectedRowData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_PRMT_ID'),
        datafield: 'paramId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
            {
              trim: true,
            },
            this.dsNodeParam, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_PRMT_NM'),
        datafield: 'paramItemName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement,
            {
              trim: true,
            },
            this.dsNodeParam, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'dsNodeParam',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'nodeId', map: 'nodeId' },
      { type: 'string', name: 'paramId', map: 'paramId' },
      { type: 'string', name: 'paramItemName', map: 'paramItemName' },
      { type: 'string', name: 'nodeParamUid', map: 'nodeParamUid' },
      { type: 'string', name: 'knoxId', map: 'knoxId' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userGlobalName', map: 'userGlobalName' },
      { type: 'string', name: 'departmentName', map: 'departmentName' },
      { type: 'string', name: 'departmentEnglishName', map: 'departmentEnglishName' },
      { type: 'string', name: 'displayLanguageId', map: 'displayLanguageId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' }],
  }],
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.nodeId)) {
        this.setNodeParamData();
      }
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /**
     * 노드 정보 및 노드 파라미터 목록 조회
     */
    setNodeParamData() {
      const queryParams = {
        nodeId: this.nodeId,
      };

      http.request(this.pageId, 'DTS_CMR_00022', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, ['finalModificationDTM']);
        this.dsNodeParam.submit();
        this.dsNodeParam.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * Grid Button Event
     */
    onClickRowAdd() {
      const defaultRow = [{
        paramId: '',
        paramItemName: '',
      }];
      this.dsNodeParam.addRows(defaultRow);
    },
    onClickRowDelete() {
      const selectedIndexes = this.dsNodeParam.getSelectedIndexes();
      this.dsNodeParam.deleteRows(selectedIndexes);
    },
    onClickRowCancel() {
      this.dsNodeParam.submit();
      this.dsNodeParam.setRawData(this.dsNodeParam.originalData);
    },
    /**
     * 저장
     */
    onClickSave() {
      const dataParams = this.rowState();

      if (!this.validationCheck()) return false;

      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMR_00023', {
          data: dataParams,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.setNodeParamData();
        });
      });

      return true;
    },
    /**
     * grid CRUD 상태값에 따른 list 추출
     */
    rowState() {
      const insertNodeParamList = [];
      const updateNodeParamList = [];
      const deleteNodeParamList = [];

      utils.forEach(this.dsNodeParam.rowStateMap, (key, value) => {
        let index = -1;
        switch (key) {
          case 'D':
            index = utils.findIndex(this.dsNodeParam.originalData, o => utils.isEqual(o['dataset-row-id'], value));
            if (index > -1) deleteNodeParamList.push(this.dsNodeParam.originalData[index]);
            break;
          case 'U':
            index = utils.findIndex(this.dsNodeParam.data, o => utils.isEqual(o['dataset-row-id'], value));
            if (index > -1) updateNodeParamList.push(this.dsNodeParam.data[index]);
            break;
          case 'C':
            index = utils.findIndex(this.dsNodeParam.data, o => utils.isEqual(o['dataset-row-id'], value));
            if (index > -1) insertNodeParamList.push(this.dsNodeParam.data[index]);
            break;
          default:
            break;
        }
      });

      return {
        insertNodeParamList,
        updateNodeParamList,
        deleteNodeParamList,
        nodeId: this.nodeId,
      };
    },
    /**
     * 입력 체크
     */
    validationCheck() {
      let flag = true;
      utils.forEach(this.dsNodeParam.data, (obj, row) => {
        if (utils.isEmpty(obj.paramId)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_PRMT_ID')),
          null,
          () => {
            this.gridSetFocus(row, 'paramId');
          });
          flag = false;
          return false;
        }
        if (utils.isEmpty(obj.paramItemName)) {
          utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_ROW_INPUT'),
            row + 1,
            this.$t('MSG_TXT_PRMT_NM')),
          null,
          () => {
            this.gridSetFocus(row, 'paramItemName');
          });
          flag = false;
          return false;
        }
        return null;
      });
      return flag;
    },
    gridSetFocus(rowIndex, datafield) {
      this.$refs.grid.$refs.grid.ensurerowvisible(rowIndex);

      const editor = this.$refs.grid.getCellEditor(rowIndex, datafield);

      if (editor) {
        editor.getComponentInstance().setFocus();
      }
    },
    /**
     * 적용
     */
    onClickApply() {
      const selectedData = this.dsNodeParam.getSelectedRows();
      if (utils.size(this.dsNodeParam.rowMap) > 0) {
        utils.messageBox('warning', this.$t('MSG_ALT_MOD_USABLE'));
        return false;
      }

      if (selectedData.length > 0) {
        const paramIdArray = [];

        utils.forEach(selectedData, obj => {
          paramIdArray.push(`\${${obj.paramId}}`);
        });

        this.$emit('paramReturn', 'paramValue', utils.join(paramIdArray, ' '));
        this.$emit('onClickClose');
      } else {
        // 선택 안했을 때
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));// 선택 된 항목이 없습니다.
      }

      return null;
    },
  },
};
</script>
<style scoped>
</style>
